import React from 'react'
import { Button } from '@lana-ui/common'

export const DoneSection = ({ handleAddMoreSuscriptions, allSelected }) => {
  return (
    <div className='flex flex-column gap-32 ai-center'>
      <div className='done-img' />
      <img src='https://especialess3.lanacion.com.ar/LN/newsletter/_common/images/newsletters-img--done-section.png' alt='Dibujo de ' width='146' height='190' />
      <div className='flex flex-column gap-8'>
        <h1 className='--prumo text-24 --font-bold text-center'>¡Listo!</h1>
        <p className='text-center'>Tus preferencias se guardaron correctamente.</p>
      </div>
      {!allSelected && <Button label='SEGUIR ADMINISTRANDO' style={{ width: '100%', maxWidth: '21.75rem' }} type='button' onClick={handleAddMoreSuscriptions} />}
    </div>
  )
}

export default DoneSection

